import {EarningList} from "./EarningList";

export const Earnings = () => {
    return (
        <EarningList/>
    )
}